import { createAction, props } from '@ngrx/store';
import { Invite } from '@fc-core';

export const invitesError = createAction(
  '[Invite/API] Invites Error',
  props<{ error: any }>(),
);

export const loadInvites = createAction('[Invite/API] Load Invites');
export const loadInvitesSuccess = createAction(
  '[Invite/API] Load Invites Success',
  props<{ invites: Invite[]; count: number }>(),
);

export const employeeInviteUpdated = createAction(
  '[Invite] Employee Invite Updated',
  props<{ employeeId: string; inviteId: string | null }>(),
);

export const resendInvite = createAction(
  '[Invite/api] Resend Invite',
  props<{ inviteId: number; employee: string }>(),
);
export const resendInviteSuccess = createAction(
  '[Invite/api] Resend Invite Success',
);
